export default {"src":"/planos/_next/static/media/representative.4c7d0fd7.svg","height":219,"width":307,"blurWidth":0,"blurHeight":0};